export default __webpack_public_path__ + "static/media/9Pack_combinado_scroll.e6d62ada.png";